import { render } from "./BindingCard.vue?vue&type=template&id=78b52c9f"
import script from "./BindingCard.vue?vue&type=script&lang=js"
export * from "./BindingCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__